<template>
    <w-flex class="grow justify-space-between basis-zero text-center mb3">
        <w-flex
            class="xs3 pa1"
            v-for="(val, index) in topWidget"
            :key="val + index"
        >
            <w-flex :style="val.color" class="bdrs3 sh-3 justify-space-evenly">
                <div class="black py3">
                    <h2>{{ val.title }}</h2>
                </div>
                <div class="black py3">
                    <h3>RM {{ val.value }}</h3>
                </div>
            </w-flex>
        </w-flex>
    </w-flex>
</template>
<script>
export default {
    name: "JumlahKutipanWidget",
    mounted() {
        this.getTopWidget();
    },
    data() {
        return {
            topWidget: [
                {
                    title: "KUTIPAN BULAN TERKINI",
                    value: "0",
                    color: "background-color: rgba(252, 79, 79, 0.6)",
                },
                {
                    title: "KUTIPAN BULAN SEBELUM",
                    value: "0",
                    color: "background-color: rgba(252, 79, 79, 0.6)",
                },
                {
                    title: "KUTIPAN SEMALAM",
                    value: "0",
                    color: "background-color: rgba(252, 79, 79, 0.6)",
                },
                {
                    title: "KUTIPAN HARI INI",
                    value: "0",
                    color: "background-color: rgba(252, 79, 79, 0.6)",
                },
            ],
        };
    },
    methods: {
        async getTopWidget() {
            const resp = await axios.get(
                "https://ihasildev.kedah.gov.my/api/dashboard-service/exec/all"
            );
            const data = resp.data;

            const colorBrownLight = "rgba(255, 159, 69, 0.6)";
            const colorBrownDark = "rgba(247, 110, 17, 0.6)";

            this.topWidget = [
                {
                    title: "KUTIPAN BULAN TERKINI",
                    value: `${data.currentMonthData || "0"}`,
                    color: `background-color:${
                        data.currentMonthData > data.lastMonthData
                            ? colorBrownLight
                            : colorBrownDark
                    }`,
                },
                {
                    title: "KUTIPAN BULAN SEBELUM",
                    value: `${data.lastMonthData || "0"}`,
                    color: `background-color:${
                        data.lastMonthData > data.currentMonthData
                            ? colorBrownLight
                            : colorBrownDark
                    }`,
                },
                {
                    title: "KUTIPAN SEMALAM",
                    value: `${data.yesterdayDateCollection || "0"}`,
                    color: `background-color:${
                        data.yesterdayDateCollection >
                        data.currentDateCollection
                            ? colorBrownLight
                            : colorBrownDark
                    }`,
                },
                {
                    title: "KUTIPAN HARI INI",
                    value: `${data.currentDateCollection || "0"}`,
                    color: `background-color:${
                        data.currentDateCollection >
                        data.yesterdayDateCollection
                            ? colorBrownLight
                            : colorBrownDark
                    }`,
                },
            ];
        },
    },
};
</script>
<style>
path:hover,
circle:hover {
    stroke: #6666ff !important;
    stroke-width: 2px;
    stroke-linejoin: round;
    fill: #6666ff !important;
    cursor: pointer;
}
</style>
